import React, { useState, useEffect, useCallback } from "react";
import ChildPic from "../../../../assets/images/child-round.png";
import ScreenShots from "./ScreenShots/ScreenShots";
import KeyStrokes from "./Keystrokes/KeyStrokes";
import Nudity from "./Nudity/Nudity";
import TimeSupervision from "./TimeSupervision/TimeSupervision";
import SetRulesDisableSupervison from "./SetRulesDisableSupervison";
import useFirebase from "../../../../useFirebase";
import { useDispatch, useSelector } from "react-redux";
import useSetRules from "./useSetRules";
// import useGetDeviceStatus from '../../../customHooks/getDeviceStatus';
import Gallery from "./Gallery/Gallery";
import Location from "./Location/Location";
import CallAndSms from "./CallAndSms/CallAndSms";
import SosSettings from "./SosSettings/SosSettings";
import SocialMedia from "./SocialMedia/SocialMedia";
import AppsMonitoring from "./AppsMonitoring/AppsMonitoring";
import WebMonitoring from "./WebMonitoring/WebMonitoring";
import VideoSettings from "./VideoSettings/VideoSettings";
import { useHistory } from "react-router-dom";
import DeleteChildInfo from "../modals/DeleteChildInfo";
import useLangTranslation from "../../../customHooks/languageProvider";
import { getMyIPAddress } from "../../AxiosRtk/Miscellaneous";
import { deleteKidAccount } from "../../AxiosRtk/AddNewChild/ADDNEWCHILDCURD";
import { setSelectedKidId } from "../../AxiosRtk/DashBoard";
import { setActiveTab } from "../../AxiosRtk/SetRules";
import DeletedSuccessfully from "../modals/DeletedSuccessfully";
import CommonStatus from "../Common/CommonStatus";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";
import { setRuleDataSetUp } from "../../AxiosRtk/SetRules";
import Select from "react-select";
// import KidImage from "../../../shared/KidImage/KidImage";
import { useDashboardDataProvider } from "../../../customHooks/dashboardDataProvider";
import useKidListFunctionality from "../../../customHooks/kidListHook";

const SetRules = () => {
  const dispatch = useDispatch();
  const { handleDeviceSelection } = useDashboardDataProvider();
  // const [activeTab, setActiveTab] = useState("SCREENSHOTS");
  // const [defaultDevice, setDeafultDevice] = useState("");
  const [deviceList, setDeviceList] = useState([]);
  const [kidData, setKidData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showDeletedModal, setShowDeletedModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [reason, setReason] = useState({ value: "", error: "" });
  const [deviceStatus, setDeviceStatus] = useState("");
  const { getImage } = useKidListFunctionality();
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );
  const [deviceOptions, setDeviceOptions] = useState([]);
  const history = useHistory();
  const { getLangTranslation } = useLangTranslation();
  const { getCollectionData } = useFirebase();

  const { handleTimeSupervision } = useSetRules();

  const { setRulesData, activeTab, setupWizardDeviceId } = useSelector(
    ({ setRules }) => setRules
  );

  const { kidList, selectedKidId, selectedDeviceData } = useSelector(
    ({ dashboard }) => dashboard
  );

  useEffect(() => {
    if (kidList?.length > 0 && selectedKidId) {
      const pickedKidData = kidList.find((item) => item.ID === selectedKidId);
      setDeviceList(pickedKidData?.KidsDevices);
      setKidData(pickedKidData);
    }
  }, [kidList, selectedDeviceData, deviceOptions]);

  useEffect(() => {
    if (selectedDeviceData) {
      getCollectionData(selectedDeviceData?.ID);
      getDeviceStatusData(selectedDeviceData?.ID);
    } else {
      dispatch(setRuleDataSetUp(null));
      setDeviceStatus("");
    }
  }, [selectedDeviceData]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  })

  const tabs = [
    { id: 1, name: "Screenshots Capturing", value: "SETRULE_SCREENSHOTS" },
    {
      id: 2,
      name: "Keystrokes Monitoring",
      value: "ONBOARD_KEYSTROKE_MONITORING",
    },
    {
      id: 3,
      name: "Nudity & Image Categorization",
      value: "SETRULE_NUDITY_AND_IMAGE_CATEGORIZATION",
    },
    { id: 4, name: "Time supervision", value: "SETRULE_TIME_SUPERVISION" },
    {
      id: 5,
      name: "Apps & Games Supervision",
      value: "SETRULE_APPS_MONITORING",
    },
    { id: 6, name: "Web Monitoring", value: "SETRULE_WEB_MONITORING" },
    { id: 7, name: "Gallery Supervision", value: "SETRULE_GALLERY_MONITORING" },
    {
      id: 8,
      name: "Location & Geofencing Settings",
      value: "SETRULE_LOCATION_AND_GEOFENCING_SETTINGS",
    },
    {
      id: 9,
      name: "SMS & Calls Supervision",
      value: "SETRULE_CALL_AND_SMS_MONITORING",
    },
    { id: 10, name: "YouTube Supervision", value: "SETRULE_VIDEO_MONITORING" },
    { id: 11, name: "SOS Settings", value: "SETRULE_SOS_SETTINGS" },
    {
      id: 12,
      name: "Social Media Communications",
      value: "SETRULE_SOCIAL_MEDIA_COMMUNICATIONS",
    },
  ];

  const getPublicIp0 = useCallback(async () => {
    try {
      const { data: ipAddData } = await getMyIPAddress();
      return ipAddData?.ip;
    } catch (error) {
      console.log("Ip0", error);
    }
  }, []);

  function closeModal() {
    setShowModal(false);
  }

  function closeDeletedModal() {
    setShowDeletedModal(false);
    setTimeout(() => {
      window.location.href = "/dashboard";
    }, 1000);
  }

  async function handleContinue() {
    if (!reason?.value) {
      setReason({
        ...reason,
        error: "Please enter reason",
      });
      return;
    }

    setLoader(true);

    const ip = await getPublicIp0();

    const deleteProfilePayload = {
      kidId: selectedKidId,
      kidName: kidData?.childName,
      ipAddress: ip,
      reason: reason?.value,
    };

    deleteKidAccount(deleteProfilePayload)
      .then((res) => {
        closeModal();
        setShowDeletedModal(true);
      })
      .catch((err) => {
        setReason({
          ...reason,
          error: err?.response?.data?.message + ". Redirecting to dashboard.",
        });
        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 2500);
        console.log(
          "child delete catch error ==>>",
          err?.response?.data?.message
        );
      })
      .finally(() => {
        setLoader(false);
        dispatch(setSelectedKidId(kidList[0]?.ID));
      });
    // console.log(deleteProfilePayload)
  }
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );
  useEffect(() => {
    // console.log(deviceList);
    setDeviceOptions(
      deviceList?.map((item) => {
        return { value: parseInt(item?.KidsDeviceId), label: item?.Name };
      })
    );
  }, [deviceList]);

  function CommonSetting() {
    return (
      <>
        {selectedDeviceData && (
          <>
            <SetRulesDisableSupervison
              enableSupervision={setRulesData?.enableSupervision}
              handleTimeSupervision={handleTimeSupervision}
              deviceSelected={selectedDeviceData?.ID}
              setRulesData={setRulesData}
            />
            <span
              className="icon-wrap pt-cursor dropdown"
              role="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="icon-setting pt-cursor" />
              <ul className="dropdown-menu col-lg-6" aria-labelledby="dropdownMenuButton1">
                <li
                  className="px-6 pt-cursor fw-semibold d-flex justify-content-between align-items-center gap-1"
                  onClick={() => history.push("/set-rules/manage-notifications")}
                >
                  {getLangTranslation("MANAGE_NOTIFICATIONS", "Manage notifications")}
                  <i className="icon-arrow-right" />
                </li>
                <li
                  className="px-6 pt-cursor d-flex fw-semibold justify-content-between align-items-center gap-1"
                  onClick={() => history.push("/set-rules/copy-settings")}
                >
                  {getLangTranslation("COPY_SETTINGS", "Copy settings")}
                  <i className="icon-arrow-right" />
                </li>
                <li
                  className="px-6 pt-cursor d-flex fw-semibold justify-content-between align-items-center gap-1"
                  onClick={() => history.push("/set-rules/default-settings")}
                >
                  {getLangTranslation("SETRULE_LOAD_DEFAULT_SETTINGS", "Load default settings")}
                  <i className="icon-arrow-right" />
                </li>
                <li
                  className="px-6 pt-cursor d-flex fw-semibold justify-content-between align-items-center gap-1 text-danger"
                  onClick={() => setShowModal(true)}
                >
                  {getLangTranslation("SET_RULES_DELETE_CHILD_PROFILE", "Delete child's profile")?.replace("child", kidData?.childName)}
                  <i className="icon-arrow-right" />
                </li>
              </ul>
            </span>

          </>
        )}

        <DeleteChildInfo
          showModal={showModal}
          closeModal={closeModal}
          handleContinue={handleContinue}
          loader={loader}
          reason={reason}
          setReason={setReason}
          getLangTranslation={getLangTranslation}
        />
      </>
    );
  }

  // console.log(defaultDevice)

  return (
    <>
      <DeletedSuccessfully
        showDeletedModal={showDeletedModal}
        closeDeletedModal={closeDeletedModal}
        msg="Child deleted successfully"
      />
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap align-items-center separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <div
                    onClick={() => history.goBack()}
                    className="text-blue-900 fs-5 pt-cursor"
                  >
                    <i
                      className={`${lang?.isRTL === 1
                        ? "icon-arrow-right"
                        : "icon-arrow-left"
                        }`}
                    />
                  </div>
                  <h3 className="text-blue-900 mb-0">
                    {getLangTranslation(
                      "CHILD_DETAIL_BUTTON_SET_RULE",
                      "SET RULES"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <span className="icon-wrap icon-rounded me-2 p-0 overflow-hidden ratio ratio-1x1 border-0">
                {/* <img src={ChildPic} alt="" /> */}
                {/* <KidImage childUrl={kidData?.image} gender={kidData?.gender} /> */}
                <img src={getImage(kidData?.image, kidData?.gender)} alt="" />
              </span>
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">{kidData?.childName}</h5>
                {/* {console.log(deviceStatus)} */}
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item col-12 col-md-3">
              <div className="select-with-icon">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                {/* {console.log(defaultDevice)} */}
                <Select
                  className="custom-select"
                  classNamePrefix="custom-select"
                  placeholder="Select Device"
                  options={deviceOptions}
                  value={
                    deviceOptions?.find(
                      (item) => item?.value == selectedDeviceData?.ID
                    ) || ""
                  }
                  onChange={handleDeviceSelection}
                  isSearchable={false}
                />
              </div>
            </div>
            <CommonSetting />
          </div>
        </div>
      </div>
      <nav>
        <div className="nav nav-tabs" id="nav-tab" role="tablist">
          {tabs?.map((item) => {
            return (
              <button
                className={`nav-link${activeTab === item?.value ? " active" : ""
                  }`}
                id={item?.value}
                type="button"
                onClick={() => dispatch(setActiveTab(item?.value))}
                key={item?.id}
              >
                {getLangTranslation(item?.value, item?.name)}
              </button>
            );
          })}
        </div>
      </nav>
      <div className="card border-0">
        <div className="card-body">
          {setRulesData?.enableSupervision ? (
            <div className="tab-content" id="nav-tabContent">
              {activeTab === "SETRULE_TIME_SUPERVISION" && (
                <div
                  className="tab-pane active"
                  id="timeSupervision"
                  role="tabpanel"
                  aria-labelledby="timeSupervisionTab"
                >
                  <TimeSupervision
                    deviceSelected={selectedDeviceData?.ID}
                    getLangTranslation={getLangTranslation}
                  />
                </div>
              )}
              {activeTab === "SETRULE_SCREENSHOTS" && (
                <div
                  className="tab-pane active"
                  id="screenShot"
                  role="tabpanel"
                  aria-labelledby="screenShotTab"
                >
                  <ScreenShots
                    deviceSelected={selectedDeviceData?.ID}
                    getLangTranslation={getLangTranslation}
                    kidData={kidData}
                  />
                </div>
              )}
              {activeTab === "ONBOARD_KEYSTROKE_MONITORING" && (
                <div
                  className="tab-pane active"
                  id="keyStrokes"
                  role="tabpanel"
                  aria-labelledby="keyStrokesTab"
                >
                  <KeyStrokes
                    deviceSelected={selectedDeviceData?.ID}
                    getLangTranslation={getLangTranslation}
                  />
                </div>
              )}
              {activeTab === "SETRULE_NUDITY_AND_IMAGE_CATEGORIZATION" && (
                <div
                  className="tab-pane active"
                  id="nudity"
                  role="tabpanel"
                  aria-labelledby="nudityTab"
                >
                  <Nudity
                    deviceSelected={selectedDeviceData?.ID}
                    getLangTranslation={getLangTranslation}
                  />
                </div>
              )}
              {activeTab === "SETRULE_APPS_MONITORING" && (
                <div
                  className="tab-pane active"
                  id="appsMonitoring"
                  role="tabpanel"
                  aria-labelledby="appsMonitoringTab"
                >
                  <AppsMonitoring
                    deviceSelected={selectedDeviceData?.ID}
                    getLangTranslation={getLangTranslation}
                  />
                </div>
              )}
              {activeTab === "SETRULE_WEB_MONITORING" && (
                <div
                  className="tab-pane active"
                  id="webMonitoring"
                  role="tabpanel"
                  aria-labelledby="webMonitoringTab"
                >
                  <WebMonitoring
                    deviceSelected={selectedDeviceData?.ID}
                    getLangTranslation={getLangTranslation}
                  />
                </div>
              )}
              {activeTab === "SETRULE_GALLERY_MONITORING" && (
                <div
                  className="tab-pane active"
                  id="gallery"
                  role="tabpanel"
                  aria-labelledby="galleryTab"
                >
                  <Gallery
                    deviceSelected={selectedDeviceData?.ID}
                    getLangTranslation={getLangTranslation}
                  />
                </div>
              )}
              {activeTab === "SETRULE_LOCATION_AND_GEOFENCING_SETTINGS" && (
                <div
                  className="tab-pane active"
                  id="location"
                  role="tabpanel"
                  aria-labelledby="locationTab"
                >
                  <Location
                    deviceSelected={selectedDeviceData?.ID}
                    getLangTranslation={getLangTranslation}
                  />
                </div>
              )}
              {activeTab === "SETRULE_CALL_AND_SMS_MONITORING" && (
                <div
                  className="tab-pane active"
                  id="callsAndSms"
                  role="tabpanel"
                  aria-labelledby="callsAndSmsTab"
                >
                  <CallAndSms
                    deviceSelected={selectedDeviceData?.ID}
                    getLangTranslation={getLangTranslation}
                  />
                </div>
              )}
              {activeTab === "SETRULE_VIDEO_MONITORING" && (
                <div
                  className="tab-pane active"
                  id="videoSettings"
                  role="tabpanel"
                  aria-labelledby="videoSettingsTab"
                >
                  <VideoSettings
                    deviceSelected={selectedDeviceData?.ID}
                    getLangTranslation={getLangTranslation}
                  />
                </div>
              )}
              {activeTab === "SETRULE_SOS_SETTINGS" && (
                <div
                  className="tab-pane active"
                  id="sosSettings"
                  role="tabpanel"
                  aria-labelledby="sosSettingsTab"
                >
                  {/* Sos Settings */}
                  <SosSettings
                    deviceSelected={selectedDeviceData?.ID}
                    getLangTranslation={getLangTranslation}
                  />
                </div>
              )}
              {activeTab === "SETRULE_SOCIAL_MEDIA_COMMUNICATIONS" && (
                <div
                  className="tab-pane active"
                  id="socialMedia"
                  role="tabpanel"
                  aria-labelledby="socialMediaTab"
                >
                  {/* Social Media */}
                  <SocialMedia
                    deviceSelected={selectedDeviceData?.ID}
                    getLangTranslation={getLangTranslation}
                  />
                </div>
              )}
            </div>
          ) : (
            <div
              className="text-center disable-supervision d-flex justify-content-center align-items-center"
              id="nav-tabContent"
            >
              <div className="">
                <p className="fw-2 fs-3">
                  {getLangTranslation(
                    "ENABLE_SUPERVISION",
                    "Please enable supervision first!"
                  )}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SetRules;
